export default __webpack_public_path__ + "static/media/PendingShiftIcon.40d532d9.svg";